<template>
  <div class="row">
    <div class="col-12">
      <div class="top__header">
        <span class="back" @click="back()">
          <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.7071 5.79289C16.0976 6.18342 16.0976 6.81658 15.7071 7.20711L10.4142 12.5L15.7071 17.7929C16.0976 18.1834 16.0976 18.8166 15.7071 19.2071C15.3166 19.5976 14.6834 19.5976 14.2929 19.2071L8.29289 13.2071C7.90237 12.8166 7.90237 12.1834 8.29289 11.7929L14.2929 5.79289C14.6834 5.40237 15.3166 5.40237 15.7071 5.79289Z"
              fill="black"
            />
          </svg>
        </span>
        <div>
          <span style="font-weight: bold; font-size: 16px">Assurance auto</span>
          <span v-if="status === 'add'" class="badge badge-pill badge-info"
            >Paiement à la livraison</span
          >
          <span
            v-if="
              status === 'negotiated' && subscription.amount_negotiated !== null
            "
            class="badge badge-pill badge-info"
            >Négocié</span
          >
          <span v-if="status === 'paid'" class="badge badge-pill badge-success"
            >Payé</span
          >
          <span
            v-if="
              status === 'negotiated' && subscription.amount_negotiated === null
            "
            class="badge badge-pill badge-info"
            >En négociation</span
          >
        </div>
        <div></div>
      </div>
      <div
        style="
          margin-top: 10px;
          display: flex;
          gap: 10px;
          flex-direction: row;
          justify-content: flex-end;
        "
      >
        <div v-if="status === 'paid'" class="dropdown dropleft">
          <button
            class="btn btn-secondary dropdown-toggle"
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            Générer le contrat
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a
              class="dropdown-item"
              @click.prevent="
                $router(
                  '/administration/contract/' +
                    subscription.uuid +
                    '/incorporation'
                )
              "
              >Conditions particulières</a
            >
            <a
              class="dropdown-item"
              @click.prevent="
                $router(
                  '/administration/contract/' + subscription.uuid + '/auto'
                )
              "
              >Attestation d’assurance automobile</a
            >
            <a
              class="dropdown-item"
              @click.prevent="
                $router(
                  '/administration/contract/' + subscription.uuid + '/cima'
                )
              "
              >Assurance Carte Brune BCEAO</a
            >
          </div>
        </div>
        <button
          @click="enCharge"
          class="btn btn-secondary btn-xs"
          v-if="status === 'add' && treat_by == null"
        >
          Prendre en charge
        </button>
        <button
          @click="showComments"
          class="btn btn-secondary btn-xs"
          v-if="
            status === 'negotiated' && subscription.amount_negotiated === null
          "
        >
          Rentrer en contact avec le client
        </button>
        <button
          @click="validatePayment"
          class="btn btn-primary"
          v-if="status === 'add' && treat_by !== null"
        >
          Valider le paiement
        </button>
        <button
          @click="showModal"
          v-if="
            (status === 'negotiated' &&
              subscription.amount_negotiated === null) ||
            (status === 'negotiated' && subscription.amount_negotiated !== null)
          "
          class="btn btn-primary"
        >
          Appliquer une réduction
        </button>
      </div>
      <div class="card__info">
        <h4>Informations client</h4>
        <div class="__first">
          <div>
            <div><strong>Nom</strong></div>
            <span>{{
              subscription.data ? subscription.data.client_name : ""
            }}</span>
          </div>
          <div>
            <div><strong>Prénom(s)</strong></div>
            <span>{{
              subscription.data ? subscription.data.client_firstname : ""
            }}</span>
          </div>
          <div>
            <div><strong>Téléphone</strong></div>
            <span>{{ subscription.user ? subscription.user.phone : "" }}</span>
          </div>
        </div>
        <div class="__first mt-2">
          <div>
            <div><strong>Email</strong></div>
            <span>{{ subscription.user ? subscription.user.email : "" }}</span>
          </div>
          <div>
            <div><strong>Adresse</strong></div>
            <span>{{
              subscription.user ? subscription.user.address : ""
            }}</span>
          </div>
          <div>
            <div><strong>Personne à contacter en cas d’urgence</strong></div>
            <span>
              {{
                subscription.user.contact_person_full_name
                  ? subscription.user.contact_person_full_name
                  : ""
              }}
              {{
                subscription.user.contact_person_number
                  ? " (" + subscription.user.contact_person_number + ")"
                  : ""
              }}
            </span>
          </div>
        </div>
      </div>
      <div class="card__info mt-2">
        <h4>Informations de souscription</h4>
        <div class="__first">
          <div>
            <div><strong>Produit</strong></div>
            <span>{{
              subscription.product ? subscription.product.name : ""
            }}</span>
          </div>
          <div>
            <div><strong>Montant (Fcfa)</strong></div>
            <span>{{ subscription ? $format(subscription.amount) : "" }}</span>
          </div>
          <div>
            <div><strong>Date de souscription</strong></div>
            <span>{{ subscription ? subscription.created_at : "" }}</span>
          </div>
        </div>
        <div class="__first mt-2" v-if="subscription?.amount_before_reduce">
          <div>
            <div><strong>Montant avant la réduction (Fcfa)</strong></div>
            <span>{{ $format(subscription.amount_before_reduce) }}</span>
          </div>
          <div>
            <div><strong>Pourcentage de réduction</strong></div>
            <span>{{ $format(subscription.per) }}%</span>
          </div>
        </div>
      </div>
      <div class="card__info mt-2">
        <h4>Formulaire de souscription</h4>
        <div class="mt-2">
          <span
            style="color: #0b2e13; padding: 10px"
            v-if="subscription.data.type_engin == '2'"
            class="badge badge-pill badge-light"
            >Véhicules à 2 ou 3 roues</span
          >
          <span
            style="color: #0b2e13; padding: 10px"
            v-else
            class="badge badge-pill badge-light"
            >Véhicules à 4 roues</span
          >
        </div>

        <div class="__first mt-2" v-if="subscription.data.type_engin == '1'">
          <div>
            <div><strong>Type de carburant </strong></div>
            <span>{{ getCarburant(subscription.data.fuel_id) }}</span>
          </div>
          <div>
            <div><strong>Puissance du moteur en chevaux (CH) </strong></div>
            <span>{{ getPower(subscription.data.power_id) }}</span>
          </div>
          <div>
            <div><strong>Catégorie du véhicule</strong></div>
            <span>{{ getCategory(subscription.data.category_id) }}</span>
          </div>
        </div>

        <div class="__first mt-2" v-else>
          <div>
            <div><strong>Type d’usage du véhicule</strong></div>
            <span>{{ getUse(subscription.data.use_type) }}</span>
          </div>
          <div>
            <div><strong>Taille du cylindre du véhicule</strong></div>
            <span>{{ getPower(subscription.data.power_id) }}</span>
          </div>
        </div>
      </div>

      <div v-if="guarantees.length > 0" class="card__info mt-2">
        <h4>Garanties</h4>
        <div class="mt-2">
          <div class="row">
            <div v-for="(item, key) in guarantees" :key="key" class="col-md-4">
              <strong>-</strong>
              <span> {{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="subscription.files != null && subscription.files.length > 0"
        class="card__info mt-2"
      >
        <h4>Fichiers joints</h4>
        <div class="mt-2">
          <div class="row">
            <div
              v-for="(item, key) in subscription.files"
              :key="key"
              class="col-md-4"
            >
              <a class="file" download :href="item.url">{{ item.name }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade text-left"
      id="negociation"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel1"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="myModalLabel1">
              Appliquer une réduction
            </h4>
            <button
              @click="errors = []"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>Montant de la réduction (FCFA)</label>
              <input
                v-model="form.montant"
                class="form-control"
                type="number"
              />
              <div v-if="errors.montant" style="color: red">
                {{ errors.montant[0] }}
              </div>
            </div>
            <div class="info_badge mt-1 mb-1">
              <span
                >Le nouveau montant de la souscription est :
                <strong>{{ reduction }} FCFA</strong></span
              >
            </div>
            <div class="row">
              <div class="col-12">
                <button
                  :class="loading || errors.length > 0 ? 'disabled' : ''"
                  @click="applyReduction()"
                  type="button"
                  class="btn btn-primary btn-block"
                >
                  Appliquer
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="comments"
      tabindex="-1"
      role="dialog"
      aria-labelledby="comments"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header" style="background-color: #fff !important">
            <h5 class="modal-title" id="comments">
              Négociation de l'assurance auto n° {{ subscription.id }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="background-color: #f8f8f8 !important">
            <div class="chat-box">
              <div
                :class="!comment.is_customer ? 'chat' : 'chat-left'"
                class="mb-2"
                v-for="(comment, key) in comments"
                :key="key"
              >
                {{ comment.message }}
              </div>
            </div>
          </div>
          <div class="modal-footer grid-item">
            <input
              @keyup.enter="sendComment"
              :class="sending ? 'error' : ''"
              v-model="comment.message"
              type="text"
              class="form-control message"
              placeholder="Tapez votre message"
            />
            <button @click="sendComment" type="button" class="btn btn-primary">
              Envoyer
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { api } from "../../../../helpers/shared";
import moment from "moment";
var $this;
export default {
  props: ["subscription", "user", "guarantees"],
  watch: {
    "form.montant": function (val) {
      if (val != "") {
        if (parseInt(val) < parseInt(this.form.amount)) {
          this.errors = [];
          this.reduction = parseInt(this.form.amount) - parseInt(val);
        } else {
          this.errors = {
            montant: [
              "La réduction est suppérieur au montant de la souscription",
            ],
          };
        }
      } else {
        this.reduction = this.subscription.amount;
        this.errors = { montant: ["Ce champ est obligatoire"] };
      }
    },
  },
  data: () => ({
    treat_by: null,
    loading: false,
    form: {
      montant: "",
      amount: "",
      uuid: "",
    },
    reduction: 0,
    errors: [],
    use_type: [
      { id: 1, name: "Personnel" },
      { id: 2, name: "Taxi" },
    ],
    fuels: [
      { id: 1, name: "Essence" },
      { id: 2, name: "Diesel" },
    ],
    powers: [
      { id: 1, name: "1 à 2 CV" },
      { id: 2, name: "3 à 6 CV" },
      { id: 3, name: "7 à 10 CV" },
      { id: 4, name: "11 à 14 CV" },
      { id: 5, name: "15 à 23 CV" },
      { id: 6, name: "24 CV et plus" },
      { id: 7, name: "1 CV" },
      { id: 8, name: "2 à 4 CV" },
      { id: 9, name: "5 à 7 CV" },
      { id: 10, name: "8 à 10 CV" },
      { id: 11, name: "11 à 16 CV" },
      { id: 12, name: "17 CV et plus" },
      { id: 13, name: "Jusqu’à 50 cm3" },
      { id: 14, name: "50 cm3 à 125 cm3" },
      { id: 15, name: "125 cm3 à 175 cm3" },
      { id: 16, name: "plus de 175 cm3" },
      { id: 17, name: "Jusqu’à 50 cm3" },
      { id: 18, name: "50 cm3 à 125 cm3" },
      { id: 19, name: "125 cm3 à 175 cm3" },
      { id: 20, name: "plus de 175 cm3" },
    ],
    categories: [
      { id: 1, name: "Promenades et affaires" },
      { id: 2, name: "Transport pour propre compte" },
      { id: 3, name: "Transport publics des marchandises" },
      { id: 4, name: "Taxi / Transport public de voyageurs" },
      { id: 5, name: "Véhicules d’autoécole" },
      { id: 6, name: "Véhicule de location" },
      { id: 7, name: "Engins à 2 ou 3 roues personnels" },
      { id: 8, name: "Engins à 2 ou 3 roues utilisée comme taxi" },
    ],
    loading: false,
    status: "",
    comment: {
      message: "",
      uuid: "",
      id: "",
    },
    sending: false,
    comments: [],
  }),
  mounted() {
    this.form.amount = this.subscription.amount;
    this.reduction = this.subscription.amount;
    this.form.uuid = this.subscription.uuid;
    this.status = this.subscription.status;
    this.treat_by = this.subscription.treat_by;
    if (
      this.status === "negotiated" &&
      this.subscription.amount_negotiated === null
    ) {
      this.getComments();
    }
  },
  created() {
    $this = this;
  },
  methods: {
    enCharge() {
      let loader = this.$loading.show({
        container: null,
        canCancel: false,
        color: "#4B4B4B",
        backgroundColor: "#4B4B4B",
        height: 35,
        width: 35,
        loader: "bars",
        opacity: 0.3,
      });
      this.loading = true;
      axios
        .post(api("administration/en-charge"), {
          id: this.subscription.id,
        })
        .then((response) => {
          this.loading = false;
          loader.hide();
          if (response.data.status) {
            this.treat_by = response.data.treat_by;
            this.treat_name = response.data.treat_name;
            this.$toasted.global.all();
          } else {
            this.$toasted.global.error({ message: "Une erreur est survenue" });
          }
        })
        .catch(() => {
          loader.hide();
          this.loading = false;
        });
    },
    formatDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    sendComment() {
      if (this.comment.message != "") {
        this.sending = false;
        this.comment.uuid = this.subscription.uuid;
        this.comment.id = this.subscription.id;
        axios.post(api("subscription/add/message"), this.comment);
        this.comment.message = "";
      } else this.sending = true;
    },
    getComments() {
      db.collection(this.subscription.uuid)
        .orderBy("createdAt")
        .onSnapshot((querySnapshot) => {
          let comments = [];
          querySnapshot.forEach((doc) => {
            comments.push(doc.data());
          });
          this.comments = comments;
        });
    },
    showComments() {
      this.$document("#comments").modal("show");
    },
    back() {
      this.$router("/administration/intGest-subscriptions");
    },
    getUse(id) {
      let item = this.use_type.find((el) => el.id == id);
      if (item) {
        return item.name;
      } else "";
    },

    getPower(id) {
      let item = this.powers.find((el) => el.id == id);
      if (item) {
        return item.name;
      } else "";
    },

    getCategory(id) {
      let item = this.categories.find((el) => el.id == id);
      if (item) {
        return item.name;
      } else "";
    },

    getCarburant(id) {
      let item = this.fuels.find((el) => el.id == id);
      if (item) {
        return item.name;
      } else "";
    },

    showModal() {
      this.errors = [];
      this.form.amount = this.subscription.amount;
      this.reduction = this.subscription.amount;
      this.form.montant = "";
      this.$document("#negociation").modal("show");
    },

    validatePayment() {
      $this.$swal
        .fire({
          title: "Êtes-vous sûr de vouloir valider ce paiement ?",
          text: "",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Oui, valider",
          cancelButtonText: "Non, annuler",
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-danger ml-1",
          },
          buttonsStyling: false,
        })
        .then(function (result) {
          if (result.value) {
            axios
              .post(api("administration/subscription/validate"), {
                id: $this.subscription.id,
                uuid: $this.subscription.uuid,
              })
              .then((response) => {
                $this.$swal.fire({
                  icon: "success",
                  title: "Opération réussie!",
                  text: "",
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                });
                $this.status = "paid";
              })
              .catch((error) => {
                if (error.response.status === 401) {
                  this.$toast.global.error({
                    message: "Votre connexion a expiré",
                  });
                } else {
                }
              });
          }
        });
    },

    applyReduction() {
      this.loading = true;
      if (this.errors.length === 0) {
        axios
          .post(api("administration/subscription/apply-reduction"), this.form)
          .then((response) => {
            this.loading = false;
            this.errors = [];
            if (response.data.status) {
              this.$document("#negociation").modal("hide");
              this.$toasted.global.all();
              setTimeout(() => {
                window.location.reload();
              }, 300);
            }
          })
          .catch((error) => {
            this.loading = false;
            if (error.response.status === 401) {
            } else {
              this.errors = error.response.data.errors;
            }
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header__title {
  font-size: 22px;
  line-height: 30px;
  color: #5e5873;
}
.back {
  cursor: pointer;
}
.top__header {
  display: grid;
  grid-template-columns: 30px 1fr 2fr;
  .header__btn {
    justify-self: end;
  }
}
.card__info {
  padding: 20px;
  height: auto;
  background: #ffffff;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  margin-top: 20px;
  .__first {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }
}
.info_badge {
  height: auto;
  padding: 10px;
  width: 100%;
  background: #e8efff;
  border-radius: 24px;
  color: #000;
}

.btn-secondary {
  color: #fff;
  background-color: #d09a12;
  border-color: #d09a12;
}

.btn-secondary:hover {
  color: #fff;
  background-color: #d09a12;
  border-color: #d09a12;
}

.btn-secondary:focus,
.btn-secondary.focus {
  color: #fff;
  background-color: #d09a12;
  border-color: #d09a12;
  box-shadow: 0 0 0 0.2rem #d09a12;
}

.btn-secondary.disabled,
.btn-secondary:disabled {
  color: #fff;
  background-color: #d09a12;
  border-color: #d09a12;
}

.btn-secondary:not(:disabled):not(.disabled):active,
.btn-secondary:not(:disabled):not(.disabled).active,
.show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: #d09a12;
  border-color: #d09a12;
}

.btn-secondary:not(:disabled):not(.disabled):active:focus,
.btn-secondary:not(:disabled):not(.disabled).active:focus,
.show > .btn-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem #d09a12;
}
.grid-item {
  display: grid;
  grid-template-columns: 3fr 1fr;
  grid-gap: 5px;
  padding: 5px;
}
.chat {
  background-color: #fff;
  padding: 10px;
  height: auto;
  width: 80%;
  border-radius: 5px;
}
.chat-left {
  background: linear-gradient(
    46.62deg,
    #001e5f 0%,
    rgba(0, 30, 95, 0.8) 93.64%
  );
  border-radius: 5px;
  color: #fff;
  text-align: right;
  padding: 10px;
  height: auto;
  width: 80%;
  margin-left: 20%;
}
.error {
  border-color: red !important;
}
.file {
  text-decoration: none;
  color: #6e6b7b;
}
</style>

